export default __webpack_public_path__ + "static/media/IMG_0102.03c636be.jpeg";